import React, { createContext, useContext, useMemo, useEffect } from "react";
import { resolveBrand } from "../config/brand";

const BrandContext = createContext(null);

export const BrandProvider = ({ children }) => {
  const brand = useMemo(() => resolveBrand(), []);

  useEffect(() => {
    document.title = brand.title;

    const setLink = (rel, href) => {
      let link = document.querySelector(`link[rel='${rel}']`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    setLink("icon", brand.assets.favicon);
    setLink("apple-touch-icon", brand.assets.appleTouchIcon);

    let manifest = document.querySelector("link[rel='manifest']");
    if (!manifest) {
      manifest = document.createElement("link");
      manifest.rel = "manifest";
      document.head.appendChild(manifest);
    }
    manifest.href = brand.assets.manifest;
  }, [brand]);

  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const ctx = useContext(BrandContext);
  if (!ctx) {
    throw new Error("useBrand must be used within BrandProvider");
  }
  return ctx;
};
